<template>
  <div>
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane
        class="paddingBody content"
        :label="$t('Flujos de aprobación de riesgos')"
        v-loading="loading"
        element-loading-text="Cargando..."
        element-loading-background="rgba(255, 255, 255)"
      >
        <el-row>
          <el-col :span="24" class="right">
            <el-button
              size="small"
              type="primary"
              @click="dialogCreateWorkflow = true"
              icon="el-icon-edit"
              v-if="faenas.includes($store.getters.role.faena_id)"
            >{{$t('Nuevo flujo de trabajo')}}</el-button>
          </el-col>
        </el-row>
        <br />
        <el-row>
          <el-table
            :header-cell-style="function () { return 'background-color: rgb(7, 116, 141); color: white; padding: 0px;'}"
            :max-height="700"
            :default-sort="{prop: 'nombre'}"
            :data="workflows"
            border
          >
            <el-table-column sortable prop="nombre" :label="$t('Flujo de Aprobación')"></el-table-column>
            <el-table-column width="150px" align="center" label="Ver">
              <template slot-scope="scope">
                <span @click="viewWorkflow(scope.row)" class="cursor">
                  <i class="el-icon-view"></i>
                  {{$t('Ver')}}
                </span>
              </template>
            </el-table-column>
            <el-table-column width="150px" align="center" label="Editar">
              <template slot-scope="scope">
                <span
                  v-if="faenas.includes($store.getters.role.faena_id)"
                  @click="showEditWorkflow(scope.row)"
                  class="cursor"
                >
                  <i class="el-icon-edit-outline"></i>
                  {{$t('Editar')}}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="Crear Workflow"
      :visible.sync="dialogCreateWorkflow"
      width="40%"
      top="60px"
      :before-close="closeDialogWorkflow"
    >
      <br />
      <div>
        <el-form label-position="top">
          <el-form-item label="Nombre">
            <el-input placeholder="Nombre del workflow" v-model="newWorkflow.nombre"></el-input>
          </el-form-item>
          <el-button
            style="margin-bottom: 20px;"
            @click="nuevoPaso()"
            icon="el-icon-plus"
            type="primary"
            size="small"
          >NUEVO PASO</el-button>
          <div v-for="(paso, index) in newWorkflow.pasos" :key="index">
            <el-form-item style="margin-bottom: 8px;">
              <el-row>
                <el-col :span="12">
                  <h3 style="margin: 0px;">PASO {{index}}</h3>
                </el-col>
                <el-col v-if="newWorkflow.pasos.length > 1" :span="12" style="text-align: right;"></el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="Roles">
              <el-select
                class="w-100"
                v-model="paso.roles"
                multiple
                placeholder="Seleccione roles a evaluar en el paso"
              >
                <el-option
                  v-for="item in rolesBHP"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Aprobaciones mínimas">
              <el-input-number
                size="small"
                v-model="paso.minAprobaciones"
                :min="0"
                :max="paso.roles.length"
              ></el-input-number>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogWorkflow">Cancelar</el-button>
        <el-button type="primary" @click="addWorkFlow()">Aceptar</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Modificar Workflow"
      :visible.sync="dialogUpdateWorkflow"
      width="40%"
      top="60px"
      :before-close="closeDialogWorkflow"
    >
      <br />
      <div>
        <el-form label-position="top">
          <el-form-item label="Nombre">
            <el-input placeholder="Nombre del workflow" v-model="newWorkflow.nombre"></el-input>
          </el-form-item>
          <el-button
            style="margin-bottom: 20px;"
            @click="nuevoPaso()"
            icon="el-icon-plus"
            type="primary"
            size="small"
          >NUEVO PASO</el-button>
          <div v-for="(paso, index) in newWorkflow.pasos" :key="index">
            <el-form-item style="margin-bottom: 8px;">
              <el-row>
                <el-col :span="12">
                  <h3 style="margin: 0px;">PASO {{index}}</h3>
                </el-col>
                <el-col v-if="newWorkflow.pasos.length > 1" :span="12" style="text-align: right;"></el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="Roles">
              <el-select
                class="w-100"
                v-model="paso.roles"
                multiple
                placeholder="Seleccione roles a evaluar en el paso"
              >
                <el-option
                  v-for="item in rolesBHP"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Aprobaciones mínimas">
              <el-input-number
                size="small"
                v-model="paso.minAprobaciones"
                :min="0"
                :max="paso.roles.length"
              ></el-input-number>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogWorkflow">Cancelar</el-button>
        <el-button type="primary" @click="updateWorkflow()">Guardar</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Visualizar Workflow"
      :visible.sync="dialogViewWorkflow"
      width="40%"
      :before-close="closeDialogWorkflow"
    >
      <div>
        <br />
        <br />
        <Workflow :workflow="newWorkflow" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogWorkflow">Cancelar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";
import Workflow from "@/components/workflows/Workflow2.vue";

export default {
  name: "listWorkflows",
  async created() {
    this.$store.dispatch(
      "setTitle",
      this.$t("Administración de flujos de aprobación")
    );
    this.$store.dispatch(
      "setSubTitle",
      this.$t("Inventario de riesgos HSE online")
    );
    this.getWorkflow();
  },
  components: {
    Workflow
  },
  data() {
    return {
      rolesBHP: [
        { value: "hse", label: "Asesor SSO" },
        { value: "health", label: "Especialista de Salud" },
        { value: "safety", label: "Especialista de Seguridad" },
        { value: "environment", label: "Especialista de Medioambiente" },
        { value: "contractor_hse", label: "Asesor SSO Contratista" },
        { value: "owner", label: "Dueño de Contrato" },
        { value: "contract_owner", label: "Dueño de Contrato" },
        { value: "risk", label: "Especialista de Riesgo" },
        { value: "administrator", label: "Administrador de Contrato" },
        { value: "contractor_coordinator", label: "Coordinador Contratista" },
        { value: "manager", label: "Gerente de Área" },
        { value: "super", label: "Superintendente de Área" },
        { value: "general_manager", label: "Gerente General" }
      ],
      id_workflow: "",
      dialogUpdateWorkflow: false,
      dialogViewWorkflow: false,
      loading: false,
      newWorkflow: {
        nombre: "",
        pasos: [
          {
            roles: [],
            minAprobaciones: 0
          }
        ]
      },
      workflows: [],
      dialogCreateWorkflow: false,
      faenas: [
        "5a6f78337b772dcfe68241d5",
        "5a6f78417b772dcfe68241e5",
        "5a6f784e7b772dcfe68241f4",
        "5b48f15d6f0ed90fc02826e3",
        "5bca28914ef25a3fcebd5b2d"
      ]
    };
  },
  methods: {
    viewWorkflow(workflow) {
      this.newWorkflow = workflow;
      this.dialogViewWorkflow = true;
    },
    updateWorkflow() {
      const self = this;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      };
      delete this.newWorkflow._id;
      axios
        .post(`/workflow/editar/${self.id_workflow}`, self.newWorkflow, config)
        .then(response => {
          if (response.status === 200) {
            self.closeDialogWorkflow();
            self.getWorkflow();
          } else {
            console.log("error");
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    deleteStep(index) {
      this.newWorkflow.pasos.splice(index, 1);
    },
    addWorkFlow() {
      let errores = [];
      if (this.newWorkflow.nombre === "") {
        errores.push(`El workflow no tiene ningún nombre asignado.`);
      }
      this.newWorkflow.pasos.forEach((paso, index) => {
        if (paso.roles.length === 0) {
          errores.push(`El paso número ${index} no tiene ningún rol asignado.`);
        }
      });
      if (errores.length === 0) {
        var self = this;
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`
          }
        };
        axios
          .post("/workflow/crear", this.newWorkflow, config)
          .then(response => {
            if (response.status === 200) {
              self.closeDialogWorkflow();
              self.getWorkflow();
            } else {
              console.log("error");
            }
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        let textError = "";
        for (let i = 0; i < errores.length; i++) {
          textError = textError + `<li class="listaError">${errores[i]}</li>`;
        }
        this.$alert(
          `<ol class="listaError">${textError}</ol>`,
          "Falta información",
          {
            type: "error",
            dangerouslyUseHTMLString: true
          }
        );
      }
    },
    closeDialogWorkflow() {
      this.dialogCreateWorkflow = false;
      this.dialogUpdateWorkflow = false;
      this.dialogViewWorkflow = false;
      this.newWorkflow = {
        nombre: "",
        pasos: [
          {
            roles: [],
            minAprobaciones: 0
          }
        ]
      };
    },
    nuevoPaso() {
      this.newWorkflow.pasos.push({
        roles: [],
        minAprobaciones: 0
      });
    },
    usuarios() {
      if (this.$store.getters.usersFaena) {
        return this.$store.getters.usersFaena;
      } else {
        return [];
      }
    },
    getWorkflow() {
      this.loading = true;
      var self = this;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        }
      };
      axios
        .get("/workflow/", config)
        .then(response => {
          this.workflows = response.data;
          self.loading = false;
        })
        .catch(error => {
          console.error(error);
        });
    },
    showEditWorkflow(workflow) {
      this.id_workflow = workflow._id;
      this.newWorkflow = JSON.parse(JSON.stringify(workflow));
      var evaluadores = [];
      this.dialogUpdateWorkflow = true;
    }
  }
};
</script>

<style scoped>
.workflowTable {
  max-height: 70vh;
  overflow: auto;
}
.workflow {
  border: solid 1px black;
  border-radius: 5px;
  margin-bottom: 20px;
  margin-right: 10px;
  margin-left: 10px;
  padding: 40px;
  text-align: center;
}
.mt-20 {
  margin-top: 20px;
}
.link {
  color: inherit;
  text-decoration: none;
}
.listaError {
  margin-left: 13px;
  padding: 0px;
  margin-bottom: 5px;
}
.right {
  text-align: right;
}
.fullHeight {
  min-height: 100vh !important;
}
.cursor {
  cursor: pointer;
}
.content {
  min-height: 50vh;
}
</style>
